import React, { useEffect } from "react";
import {
  Typography,
  Grid,
  Box,
  Button,
  Card,
  CardContent,
  Tooltip,
} from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function Schedule(props) {
  const {
    state,
    onState,
    activeStep,
    name,
    number_of_trainee,
    description,
    application,
    config_value,
    template,
    start_date,
    end_date,
    start_time,
    stop_time,
    depends_on,
    repeat_frequency,
    // every,
    on_days,
    startcron_expression,
    // stopcron_expression,
    startcron_expression2,
    // stopcron_expression2,
    // cpu_count,
    // email,
    budget,
    // env_keep,
    // feedback,
    // feedback_no,
    feedBack_date,
    // machine_count,
    // manage_labs,
    env_keep_date,
    meeting_url,
    budgethours,
    billingtype,
    // disable_copypaste_guac,
    // budgetStorageHours,
    // hourlyBasedAmount,
    selectedRelatedLabType,
    selectedMasterLabId,
    // guacmoleLabState,
    // selectedMasterOrRelatedLab,
    // isCustomized,
    handleBack,
    handleSubmitClick,
    stepslength,
  } = props;


  let email;
  if (state.email) {
    email = state.email;
  } else {
    email = localStorage.getItem("email");
  }
  // If you need to use `const`, you can reassign it after determining the value
  // const finalEmail = email;
  const guacmoleLabState = state.guacmoleLabState ? "yes" : "no";
  // const master_or_realated = state.guacmoleLabState ? "related" : "master";
  const feedback = (state.feedbackno && state.selectedDates) ? "Yes" : "No";
  const isCustomized = state.isCustomized ? "Yes" : "No";
  const env_keep = state.env_keep ? "yes" : "no";
  
  // const addvalue = { ...state.customization };  // Create a copy of the customized_variable to avoid modifying the original state object
  // addvalue.lab_name = state.name;
  // addvalue.Application_Name = state.application;
  // addvalue.master_count = state.nooftrainee;
  // addvalue.node_count = state.machine_count;
  // addvalue.start_time = state.startcron_expression;
  // addvalue.stop_time = state.stopcron_expression;
  // delete addvalue.cpu_count;

  // const customized_value = JSON.stringify(addvalue);
  
  const manage_labs = (state.manageState && state.depends_on === "during_training") ? "yes" : "no";
  // const disable_copypaste_guac = state.disable_copypaste ? "yes" : "no";

  var disable_copypaste_guac;
  if (state.disable_copypaste) {
    disable_copypaste_guac = "yes";
  } else {
    disable_copypaste_guac = "no";
  }

  let parsedVariables = {};
  try {
    parsedVariables = config_value; // No need to parse, already an object
   
  } catch (error) {
    console.error("Error parsing customized_variable:", error);
  }

  const [instancetype, setInstancetype] = React.useState([[]]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/instancetype/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((resp) => setInstancetype(resp))
      .catch((error) => {
        console.error(error);
      });
  }, []);

   const compareAndDisplay = (template, config_value) => {
    try {
        if (!Array.isArray(template)) {
            console.error("Error: template is not an array", template);
            return [];
        }
        if (typeof config_value !== "object" || config_value === null) {
            console.error("Error: config_value is not a valid object", config_value);
            return [];
        }
        
        return template
          .map((item) => {
              const configKey = item.name;
              const displayName = item.title;

              if (config_value.hasOwnProperty(configKey)) {
                  let value = isCustomized === "Yes" ? config_value[configKey] : item.default;

                  // Handle ports and storage formatting
                  if (isCustomized === "Yes" && (configKey.endsWith("_ports") || configKey.endsWith("_storage"))) {
                      value = Array.isArray(value) ? value.join(", ") : String(value);
                  }

                  // Lookup instance type title
                  if (isCustomized === "Yes" && configKey.endsWith("_instance_type")) {
                      const matchedInstance = instancetype.find(inst => inst.instance_type === value);
                      value = matchedInstance ? matchedInstance.title : value;
                  }

                  return { key: displayName, value };
              }

              return null;
          })
          .filter(Boolean);

    } catch (error) {
        console.error("Error in compareAndDisplay:", error);
        return [];
    }
};
  

  // Get the result
  const result = Array.isArray(template) ? compareAndDisplay(template, config_value) : [];
  
  const capitalizeFirstLetter = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  const getFormattedDays = (cronExpression) => {
    const cronParts = cronExpression.split(" ");
    const monthNumber = cronParts[cronParts.length - 2]; // Extract month number before '?'
    const monthNames = { "1": "Jan", "2": "Feb", "3": "March", "4": "April", "5": "May", "6": "June", "7": "July", "8": "Aug", "9": "Sep", "10": "Oct", "11": "Nov", "12": "Dec"  }; // Add more months if needed
    const month = monthNames[monthNumber] || "Unknown";
    const days = cronParts.slice(2, cronParts.length - 2)[0]?.split(",") || [];
    return days.map((day) => `${month}-${day.trim()}`).join(", ");
  };

 return (
    <div>
      <Card
        style={{
          height: "auto",
          backgroundColor: "#06396c",
          color: "#000000",
          borderRadius: "16px",
          margin: "6px",
          padding: "6px",
          width: "100%",
          maxWidth: "1000px",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        <CardContent
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
            gap: "16px",
            padding: "0",
          }}
        >
          {/* Lab Information Column */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "4px",
              padding: "16px",
              backgroundColor: "#FFFFFF",
              borderRadius: "8px",
            }}
          >
            <Typography
              variant="h5"
              style={{ marginBottom: "8px", color: "#262626", textAlign: "center" }}
            >
              Lab Information
            </Typography>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                Lab Name:
              </Typography>
              <Typography variant="body1">{name}</Typography>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                Application:
              </Typography>
              <Typography variant="body1">{capitalizeFirstLetter(application)}</Typography>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                Customaized Application:
              </Typography>
              <Typography variant="body1">{isCustomized}</Typography>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                Trainees:
              </Typography>
              <Typography variant="body1">{number_of_trainee}</Typography>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                Description:
              </Typography>
              <Typography variant="body1">{description || "N/A"}</Typography>
            </div>
          </div>

          {/* Schedule Information Column */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "4px",
              padding: "16px",
              backgroundColor: "#FFFFFF",
              borderRadius: "8px",
            }}
          >
            <Typography
              variant="h5"
              style={{ marginBottom: "8px", color: "#262626", textAlign: "center" }}
            >
              Schedule Information
            </Typography>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                Start Date:
              </Typography>
              <Typography variant="body1">
                {start_date.split('-').reverse().join('-')}
              </Typography>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                End Date:
              </Typography>
              <Typography variant="body1">
                {end_date.split('-').reverse().join('-')}
              </Typography>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                Start Time:
              </Typography>
              <Typography variant="body1">{start_time}</Typography>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                Stop Time:
              </Typography>
              <Typography variant="body1">{stop_time}</Typography>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                Schedule Type:
              </Typography>
              <Typography variant="body1">{capitalizeFirstLetter(depends_on)}</Typography>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                Repeat_Frequency:
              </Typography>
              <Typography variant="body1">
                {depends_on === "during_training" ? capitalizeFirstLetter(repeat_frequency) : "N/A"}
              </Typography>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
              <Typography variant="body1" style={{ fontWeight: "bold", marginRight: "10px" }}>
                Days:
              </Typography>
              <div>
                {depends_on === "during_training" && repeat_frequency === "day" ? (
                  <>
                    {(
                      [...getFormattedDays(startcron_expression).split(","), ...getFormattedDays(startcron_expression2).split(",")]
                        .reduce((acc, date, index, arr) => {
                          if (index % 2 === 0) {
                            acc.push(arr.slice(index, index + 2).join(", "));
                          }
                          return acc;
                        }, [])
                        .map((pair, index) => (
                          <Typography key={index} variant="body1">
                            {pair}
                          </Typography>
                        ))
                    )}
                  </>
                ) : (
                  <Typography variant="body1">N/A</Typography>
                )}
              </div>
            </div>

            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                Weekly on:
              </Typography>
              <Typography variant="body1">
                {(depends_on === "during_training" && repeat_frequency === "week") ? on_days  : "N/A"}
              </Typography>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                Billing Type:
              </Typography>
              <Typography variant="body1">
                {billingtype === "budgetbased" ? "Budget" : "Hourly"}
              </Typography>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                {billingtype === "budgetbased" ? "Budget Amount" : "Hours"}:
              </Typography>
              <Typography variant="body1">
                {billingtype === "budgetbased" ? budget : budgethours}
              </Typography>
            </div>
          </div>

          {/* Parameters Information Column */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "4px",
              padding: "16px",
              backgroundColor: "#FFFFFF",
              borderRadius: "8px",
            }}
          >
            <Typography
              variant="h5"
              style={{ marginBottom: "8px", color: "#262626", textAlign: "center" }}
            >
              Parameters Information
            </Typography>
            <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                Notification Email:
              </Typography>
              <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
                {email.split(",").map((emailItem, index) => (
                  <Typography key={index} variant="body1" style={{ display: "block" }}>
                    {emailItem.trim()}
                  </Typography>
                ))}
              </div>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                Related Lab Information:
              </Typography>
              <Typography variant="body1">{guacmoleLabState === "yes" ? `Lab Type : ${selectedRelatedLabType} | Master Lab Id : ${selectedMasterLabId}`  : "No"}</Typography>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
              <Typography variant="body1" style={{ fontWeight: "bold", marginRight: "10px" }}>
                Feedback:
              </Typography>
              <div>
                {feedback === "Yes" ? (
                  feedBack_date
                    .split(",")
                    .map((date) => date.trim().replace(/\//g, "-")) // Replace '/' with '-'
                    .reduce((acc, date, index, arr) => {
                      if (index % 2 === 0) {
                        acc.push(arr.slice(index, index + 2).join(", "));
                      }
                      return acc;
                    }, [])
                    .map((pair, index) => (
                      <Typography key={index} variant="body1">
                        {pair}
                      </Typography>
                    ))
                ) : (
                  <Typography variant="body1">No</Typography>
                )}
              </div>
            </div>


            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                Manage Labs:
              </Typography>
              <Typography variant="body1">{manage_labs === "yes" ? manage_labs : "No"}</Typography>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                Keep Lab Environment:
              </Typography>
              <Typography variant="body1">
              </Typography>
              <Typography variant="body1">{env_keep === "yes" ? env_keep_date.split('-').reverse().join('-') : "No"}</Typography>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                Meeting Url:
              </Typography>
              <Typography
                variant="body1"
                style={{ wordBreak: "break-word", maxWidth: "50%" }}
              >
                {meeting_url !== "" ? meeting_url : "No"}
              </Typography>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="body1" style={{ fontWeight: "bold" }}>
                Disable Copypaste for instance:
              </Typography>
              <Typography variant="body1">{disable_copypaste_guac === "yes" ? "Yes" : "No"}</Typography>
            </div>
          </div>
        </CardContent>
        <div>&ensp;</div>
        {/* Accordion Section - Customized Variables */}
        <Accordion square>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="customized-variables-content"
            id="customized-variables-header"
          >
            <Typography variant="h5">Server Information</Typography>
          </AccordionSummary>
          <AccordionDetails
            style={{
              maxHeight: "300px",
              overflowY: "auto",
            }}
          >
            {/* Responsive grid layout with three columns */}
            <Grid container spacing={2}>
              {result.map(({ key, value }) => (
                <Grid item xs={12} sm={6} md={4} key={key}>
                  <Card 
                    variant="outlined" 
                    sx={{ 
                      borderRadius: "8px", 
                      textAlign: "center", 
                      height: "100%", 
                    }}
                  >
                    <CardContent>
                      <Typography variant="subtitle1">
                        <strong>{key}:</strong> {value}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Card>

      {/* Buttons outside of the card */}
      <Box display="flex" justifyContent="space-between" mt={2}>
        <Tooltip title="Cancel and reload this review">
          <span>
            <Button variant="contained" color="secondary" onClick={() => window.location.reload()} sx={{ borderRadius: '50px' }}>Cancel</Button>
          </span>
        </Tooltip>
        <Box>
          {activeStep !== 0 && (
            <Tooltip title="Go back to previous step">
              <span>
                <Button onClick={handleBack} variant="contained" sx={{ mr: 0.5, borderRadius: '50px' }}>Back</Button>
              </span>
            </Tooltip>
          )}
          <Tooltip title="Submit your lab deployment request">
            <span>
              <Button variant="contained" color="primary" onClick={handleSubmitClick} sx={{ borderRadius: '50px' }}>Create</Button>
            </span>
          </Tooltip>
        </Box>
      </Box>
    </div>
  );
}
